import React from 'react'
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { Container, Col, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import "../../../Assets/css/mjstatic.css"
import '../../../Assets/css/cbrPrivacypolicy.css'
import { useSelector } from 'react-redux';
import {client_name } from '../../../Helpers/request';

const ShippingReturnsPoicy = () => {
    // const Email_details_link =  Email_details.link
    const metaDetails = useSelector(state => state.persistedReducer.meta.meta)
  return (
    <>
 <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails.title}</title>
                <meta name="description" content={metaDetails.description}></meta>
                <meta name="keywords" content={metaDetails.keywords}></meta>
            </Helmet>
            <div className="rcs_ringsetting_section mt-3">
                <Container>
                    <Row>
                        <Col className="rcs_breadcrumb m-0 mb-md-2">
                            <Breadcrumbs aria-label="breadcrumb">
                                <NavLink underline="hover" color="inherit" to="/">
                                    Home
                                </NavLink>
                                <Typography color="text.primary">Shipping</Typography>
                            </Breadcrumbs>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} lg={12} md={12}>
                        <div className="cbr_shipping_contents rcs_privacy_content mt-5 mb-5">
                          <h1>SHIPPING</h1>
                          <div className='cbr_shipping_first'>
                            <ul>
                             <li>
                                <p>Upon successfully placing any order for delivery within the United States of America, 
                                including APO, the Customer can expect a delivery in approximately 7-10 days. 
                                When the item is shipped, a tracking number will be provided to the Customer by email.</p></li>
                                <li>
                                <p>
                                If Customer places an order before the cutoff time on a regular business day (Monday through Friday), the order will begin processing that day. 
                                If Customer places an order on a holiday, 
                                Saturday or Sunday, or after the cutoff on a regular business day, the order will begin processing the following business day.
                                </p></li>
                                <li>
                                <p>We provide Customer with an option to deliver the products to an alternate address if the Customer is not available at the billing address to receive the order. As a security precaution to protect the Customer against fraud,
                                {client_name.c_name}  might confirm that your credit card or financing company has this alternate shipping address on file. 
                                    To help expedite your order, simply call your issuing bank and provide them with your alternate shipping address.</p>
                                </li>
                                <li>
                                <p>If Customer cannot be available at the time of delivery of the order, or does not have someone else available to sign for the package, Customer can have it shipped to a local hold for pick-up location. 
                                    To schedule a hold for pick-up, contact  {client_name.c_name}at 
                                    <a href="tel:(678)722-5664">  678-722-5664  </a>
                                    or  <a href="tel:(855) 522-3663">  855-522-3663  </a>
                                     to specify details.</p>
                                </li>
                                <li>
                                <p>
                                If your package from  {client_name.c_name}appears to be damaged when you are asked to sign the delivery release, please don’t accept the package until you check the contents to assure the product is intact. If your purchase is missing an item or appears to be damaged, do not sign the release and have the package returned to sender. 
                                If you sign for the package, you become responsible for its contents. If after accepting the package, you discover damage, call us immediately at 
                                <a href="tel:(678)722-5664">  678-722-5664  </a>
                                    or  <a href="tel:(855) 522-3663">  855-522-3663 </a>
                                 Please retain all packing materials unless instructed otherwise by us.
                                 {client_name.c_name}  shall not be responsible for lost or damaged returned shipments.
                                </p>
                                </li>
                                <li>
                                <p>
                                {client_name.c_name} is not responsible for lost or stolen articles while in your possession.   
                                </p>
                                </li>
                            </ul>
                            <h3>RETURNS</h3>
                            <ul>
                            <li>
                            <p>We offer convenient and easy online returns for items which are eligible for returns or exchanges 
                                under our refund and cancellation Policy. Custom jewelry is not eligible for return. </p>
                            </li>
                            <li><p>User must pack the item(s) securely in the original packing materials. If return is for refund or exchange, please include all diamond grading reports. If the original, laminated certificate is not included, 
                                a fee of $250 will be added to replace the certificate. Diamond grading reports and appraisals are not required for repairs and resizes</p></li>
                            <li><p>If you wish to change or cancel an order, contact {client_name.c_name}. We will attempt to accommodate order changes to the extent possible prior to shipping confirmation. Some changes will result in a shipping delay. We cannot accommodate changes or cancellations to orders that have already processed. If your order has already shipped, 
                                please contact us to initiate a return request once you have received the product.</p></li>
                            <li><p>Received returns are entered into our system within 24 business hours of receipt of package. 
                                Once returns have been entered into our system you will receive a confirmation email alerting you 
                                that your return has been accepted by our Quality Assurance Team and the process will be completed within 7 – 10 days. 
                                The Quality Assurance Team is responsible for video recording the opening of 
                                each returned package to validate the return and provide documentation should a discrepancy arise.</p></li>
                                <li><p>Customers can check the status of returned items by calling <a href="tel:(678)722-5664"> 678-722-5664 </a>
                                or
                                <a href="tel:(855) 522-3663"> 855-522-3663 </a>
                                 </p></li>
                            </ul>
                            <h3>REFUND AND EXCHANGE POLICY</h3>
                            <ul>
                            <li><p>Custom orders are not returnable or exchangeable. Custom orders include items that were sized, engraved, specially designed or modified in any way. You may return or exchange any non-custom item you received from 
                            {client_name.c_name} within 30 days after delivery date. 
                                For in-store purchases, the 30-day period begins when first payment is made.</p></li>
                            <li><p>Call {client_name.c_name} at <a href="tel:(678)722-5664"> 678-722-5664 </a> or
                            <a href="tel:(855) 522-3663"> 855-522-3663 </a>to initiate the return. 
                                If your item is eligible for return and you will be shipping the item, you will receive an RMA number which must be displayed 
                                on the outside of the return package. Any package received by {client_name.c_name} without an RMA number will be refused.
                                 Please note that to be eligible for return, items must be in their original, unworn and unused condition, 
                                 and include all product documentation, and be returned within the time frame describe above. 
                                Resubmitted returns are still bound by the original 30 day limit.</p></li>
                            <li><p>It may take your bank up to 3 business days to post the funds to your account. 
                                Returned orders with bank wire as the original payment method will be refunded via check.
                                 Checks are sent via regular US Mail to the billing address in the original order (unless otherwise requested) 
                                 and typically deliver within 7 -10 days after the return has processed. Orders paid through PayPal will be 
                                 credited back to your PayPal account within 3 days.</p></li>
                            <li><p>Customers can check the status of returned items by calling 
                            <a href="tel:(678)722-5664">  678-722-5664  </a>
                            or
                            <a href="tel:(855) 522-3663">  855-522-3663  </a>
                                
                                </p></li>

 


                            </ul>
                          </div>
                        </div>

                        </Col>
                    </Row>































































                    </Container>
                    </div>
    </>
  )
}

export default ShippingReturnsPoicy
